import { fg_busy } from "@clockwise/design-system/tokens";
import { ConferencingType } from "@clockwise/schema";
import { TrackingEvents, useTracking } from "@clockwise/web-commons/src/util/analytics.util";
import { VideocamOutlined } from "@material-ui/icons";
import React from "react";
import { ListItemButton } from "../calendar-popover/atoms/ListItemButton";
import { VideoLink } from "./EventContextMenu";

const openVideoLink = (url: string) => {
  window.open(url, "openVideoLink");
};

const getColorFromVideoType = (type: ConferencingType) => {
  switch (type) {
    case ConferencingType.ZOOM:
      return "#3170E3";
    case ConferencingType.MEET:
      return "#3170E3";
    case ConferencingType.TEAMS_FOR_BUSINESS:
      return "#5C5FC1";
    case ConferencingType.AROUND:
      return "#5C5FC1";
    default:
      return fg_busy;
  }
};

const getLabelFromVideoType = (type: ConferencingType) => {
  switch (type) {
    case ConferencingType.ZOOM:
      return <span className="cw-text-[#3170E3] cw-font-medium">Join with Zoom</span>;
    case ConferencingType.MEET:
      return <span className="cw-text-[#3170E3] cw-font-medium">Join with Google Meet</span>;
    case ConferencingType.TEAMS_FOR_BUSINESS:
      return <span className="cw-text-[#5C5FC1] cw-font-medium">Join with Microsoft Teams</span>;
    case ConferencingType.AROUND:
      return <span className="cw-text-[#5C5FC1] cw-font-medium">Join with Around</span>;
    default:
      return <span className="cw-text-busy cw-font-medium">Join virtual call</span>;
  }
};

export const JoinVideoLink = ({
  videoLink,
  onClose,
}: {
  videoLink: VideoLink;
  onClose: () => void;
}) => {
  const track = useTracking();

  const onClick = () => {
    track(TrackingEvents.EVENT_POPOVER.MEETING_JOINED);
    openVideoLink(videoLink.uri);
    onClose();
  };

  const textColor = getColorFromVideoType(videoLink.type);

  return (
    <ListItemButton startIconColor={textColor} startIcon={VideocamOutlined} onClick={onClick}>
      {getLabelFromVideoType(videoLink.type)}
    </ListItemButton>
  );
};
